import axios from "axios";
import { getHeaders } from "./index";
import { ROOT_API_URL } from "../app.config";
import { getProfileId } from "./profile.service";

const OWNER_ID = "owner_id";
const CONTACT_ID = "contact_id";
const SLUG = "slug";
const CONTACTS_URL = `${ROOT_API_URL}/profile/contacts/`;
const CONTACT_CARD_URL = `${ROOT_API_URL}/profile/contact-card/`;
const REMOVE_CONTACT_URL = `${ROOT_API_URL}/profile/remove-contact/`;
const CONTACT_INVITES_URL = `${ROOT_API_URL}/profile/api/contact-invites/`;
const CONTACT_DETAILED_INVITES_URL = `${ROOT_API_URL}/profile/api/contact-invites-detailed`;

export const getContacts = ownerId => {
  return axios.get(`${CONTACTS_URL}?${OWNER_ID}=${ownerId || getProfileId()}`, {
    headers: getHeaders()
  });
};

export const getContactCard = slug => {
  return axios.get(`${CONTACT_CARD_URL}?${SLUG}=${slug}`);
};

export const addContact = payload => {
  return axios.post(CONTACTS_URL, payload, {
    headers: getHeaders()
  });
};

export const deleteContact = payload => {
  return axios.post(REMOVE_CONTACT_URL, payload, {
    headers: getHeaders()
  });
};

export const getContactInvites = profileId => {
  return axios.get(`${CONTACT_DETAILED_INVITES_URL}/?search=${profileId}`, {
    headers: getHeaders()
  });
};

export const createContactInvite = payload => {
  return axios.post(CONTACT_INVITES_URL, payload, {
    headers: getHeaders()
  });
};

export const updateContactInvite = ({ id, status }) => {
  return axios.patch(
    `${CONTACT_INVITES_URL}${id}/`,
    { status },
    {
      headers: getHeaders()
    }
  );
};

// http://localhost:8000/profile/api/contact-invites?search=101



// WEBPACK FOOTER //
// ./src/services/contacts.service.js